<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('observations.type_title')"/>
    <div class="col-sm-12 nopads my-2">
        <observation-type-list
          :results="results"
          @add="add"
          @edit="edit"
        />
    </div>
        <base-modal v-if="editMode" hide-footer hide-header size="lg" @close="editMode = false">
            <observation-type-editor
                :observation-type="observationType"
                @close="showList"
                @close-and-update="closeAndUpdate"
            />
        </base-modal>
    <div
        v-if="loading"
        id="loader"
        class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {observationHelper} from '../../mixins/ObservationMixin'
import ObservationTypeList from './ObservationTypeList'
import ObservationTypeEditor from './ObservationTypeEditor'
import BaseModal from "@/components/BaseModal";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'ObservationTypes',
    components: {Navbar, BaseModal, ObservationTypeList, ObservationTypeEditor},
    mixins: [restApi, observationHelper],
    data: function () {
        return {
            results: [],
            observationType: null,
            editMode: false,
            loading: false
        }
    },
    mounted: function () {
        this.fetchObservationTypes()
    },
    methods: {
        fetchObservationTypes: function () {
            this.loading = true
            this.restFetch(this.observationTypeUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        add: function () {
            this.observationType = this.newObservationType()
            this.editMode = true
        },
        edit: function (obsType) {
            this.observationType = obsType
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchObservationTypes()
            this.showList()
        }
    }
}
</script>
